// import React, { useState } from 'react';
// import { useDropzone } from 'react-dropzone';
// import Box from '@mui/material/Box';

// const DropzoneWithPreview = ({ type, handleFileUpload, initialImage, disabled }) => {
//   console.log(initialImage, 'Submitting form with valuesSubmitting form with values');
//   const [preview, setPreview] = useState(initialImage || null);

//   const onDrop = (acceptedFiles) => {
//     if (disabled || !acceptedFiles || acceptedFiles.length === 0) return;
//     const file = acceptedFiles[0];
//     const previewUrl = URL.createObjectURL(file);
//     setPreview(previewUrl);
//     handleFileUpload(type, acceptedFiles);
//   };

//   const { getRootProps, getInputProps, isDragActive } = useDropzone({
//     accept: 'image/jpeg, image/png',
//     onDrop,
//     disabled,
//   });

//   console.log(preview, 'preview test');

//   // decide container dimensions per type
//   const containerSize =
//     type === 'logo'
//       ? { width: '350px', height: '150px' }
//       : type === 'image'
//       ? { width: '150px', height: '150px' }  // profile
//       : { width: '150px', height: '150px' }; // banner

//   // decide image styling per type
//   const imgStyle =
//     type === 'image'
//       ? { width: '100%', height: '100%', objectFit: 'cover' }
//       : { width: '100%', height: 'auto', objectFit: 'contain' };

//   return (
//     <Box
//       {...getRootProps()}
//       sx={{
//         position: 'relative',
//         border: '3px dashed black',
//         backgroundColor:' #CBCBCB',
//         borderRadius: '4px',
//         overflow: 'hidden',
//         mb: disabled ? 0 : 2,
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         ...containerSize,
//       }}
//     >
//       <input {...getInputProps()} />
//       {preview ? (
//         <img
//           src={
//             preview.startsWith('blob')
//               ? preview
//               : `${process.env.REACT_APP_API_ROUTE}/files/${preview}`
//           }
//           style={imgStyle}
//         />
//       ) : (
//         <Box sx={{ textAlign: 'center', p: 2 }}>
//           {isDragActive ? (
//             disabled ? (
//               <p>
//                 No{' '}
//                 {type === 'logo'
//                   ? 'Logo'
//                   : type === 'image'
//                   ? 'Profile'
//                   : 'Banner'}{' '}
//                 image uploaded
//               </p>
//             ) : (
//               <p>
//                 Drop the{' '}
//                 {type === 'image' ? 'Profile' : 'Banner'} image here…
//               </p>
//             )
//           ) : disabled ? (
//             <p>
//               No{' '}
//               {type === 'image'
//                 ? 'Profile'
//                 : type === 'logo'
//                 ? 'Logo'
//                 : 'Banner'}{' '}
//               image uploaded
//             </p>
//           ) : (
//             <p>
//               Drag &amp; drop{' '}
//               {type === 'logo'
//                 ? 'Logo'
//                 : type === 'image'
//                 ? 'Profile'
//                 : 'Banner'}{' '}
//               image here,
//               <br />
//               or click to select file
//             </p>
//           )}
//         </Box>
//       )}
//     </Box>
//   );
// };

// export default DropzoneWithPreview;



// import React, { useCallback, useEffect, useState } from 'react';
// import { useDropzone } from 'react-dropzone';
// import { useField, useFormikContext } from 'formik';
// import { Box, Typography, FormHelperText } from '@mui/material';

// const DragDropImageField = ({ name, recommendedRatio = '226:133', maxSizeMB = 10, accept = 'image/*' }) => {
//   const { setFieldValue, setFieldTouched } = useFormikContext();
//   const [field, meta] = useField(name);
//   const [preview, setPreview] = useState(field.value || null);

//   // Generate preview URL when file changes
//   useEffect(() => {
//     if (field.value && field.value instanceof File) {
//       const objectUrl = URL.createObjectURL(field.value);
//       setPreview(objectUrl);
//       return () => URL.revokeObjectURL(objectUrl);
//     }
//     if (!field.value) {
//       setPreview(null);
//     }
//   }, [field.value]);

//   const onDrop = useCallback(
//     (acceptedFiles, fileRejections) => {
//       // handle rejections (size, type)
//       if (fileRejections.length > 0) {
//         // you can handle errors here or rely on Formik validation
//         return;
//       }
//       const file = acceptedFiles[0];
//       setFieldValue(name, file);
//       setFieldTouched(name, true);
//     },
//     [name, setFieldValue, setFieldTouched]
//   );

//   const { getRootProps, getInputProps, isDragActive } = useDropzone({
//     onDrop,
//     multiple: false,
//     maxSize: maxSizeMB * 1024 * 1024,
//     accept,
//   });

//   return (
//     <Box>
//       <Box
//         {...getRootProps()}
//         sx={{
//           border: '1px dashed gray',
//           borderRadius: 1,
//           p: 2,
//           textAlign: 'center',
//           cursor: 'pointer',
//           '&:hover': { backgroundColor: '#f9f9f9' }
//         }}
//       >
//         <input {...getInputProps()} />
//         {preview ? (
//           <Box component="img" src={preview} alt="preview" sx={{ maxWidth: '100%', maxHeight: 200 }} />
//         ) : (
//           <Typography variant="body2" color="textSecondary">
//             {isDragActive ? 'Drop the image here...' : 'Drag & drop Food Item image here, or click to select file'}
//           </Typography>
//         )}
//       </Box>
//       <Typography variant="caption" color="textSecondary" display="block" mt={1}>
//         Recommended ratio is {recommendedRatio}. Supported formats: PNG, JPG, and JPEG. Maximum file size: {maxSizeMB}MB.
//       </Typography>
//       {meta.touched && meta.error && (
//         <FormHelperText error>{meta.error}</FormHelperText>
//       )}
//     </Box>
//   );
// };

// // DragDropImageField.propTypes = {
// //   name: PropTypes.string.isRequired,
// //   recommendedRatio: PropTypes.string,
// //   maxSizeMB: PropTypes.number,
// //   accept: PropTypes.string,
// // };

// export default DragDropImageField;



// // ImageDropzone.jsx
// import React, { useCallback, useEffect, useState } from 'react';
// import { useDropzone } from 'react-dropzone';
// import { Box, Paper, Typography } from '@mui/material';

// const ImageDropzone = ({ fieldName, formik }) => {
//   const { setFieldValue, touched, errors } = formik;
//   const [preview, setPreview] = useState(null);

//   // regenerate preview URL when file changes
//   useEffect(() => {
//     if (!formik.values[fieldName]) {
//       setPreview(null);
//       return;
//     }
//     const objectUrl = URL.createObjectURL(formik.values[fieldName]);
//     setPreview(objectUrl);
//     return () => URL.revokeObjectURL(objectUrl);
//   }, [formik.values, fieldName]);

//   const onDrop = useCallback(
//     (files) => setFieldValue(fieldName, files[0]),
//     [setFieldValue, fieldName]
//   );

//   const { getRootProps, getInputProps, isDragActive } = useDropzone({
//     onDrop,
//     accept: { 'image/png': [], 'image/jpeg': [], 'image/jpg': [] },
//     maxSize: 10 * 1024 * 1024,
//     multiple: false,
//   });

//   return (
//     <Box>
//       <Paper
//         {...getRootProps()}
//         elevation={0}
//         sx={{
//           p: 0,
//           height: 250,
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: 'center',
//           justifyContent: 'center',
//           border: '2px dashed #ccc',
//           borderRadius: 2,
//           bgcolor: 'background.default',
//           position: 'relative',
//           textAlign: 'center',
//           cursor: 'pointer'
//         }}
//       >
//         <input {...getInputProps()} />

//         {preview ? (
//           <Box
//             component="img"
//             src={preview}
//             alt="Preview"
//             sx={{
//               maxHeight: '100%',
//               maxWidth: '100%',
//               objectFit: 'contain',
//               borderRadius: 1
//             }}
//           />
//         ) : (
//           <Typography variant="body2" sx={{ px: 2 }}>
//             {isDragActive
//               ? 'Release to drop the image here'
//               : 'Drag & drop Food Item image here,\nor click to select file'}
//           </Typography>
//         )}

//         {/* error under the preview */}
//         {touched[fieldName] && errors[fieldName] && (
//           <Typography
//             variant="caption"
//             color="error"
//             sx={{ position: 'absolute', bottom: 40 }}
//           >
//             {errors[fieldName]}
//           </Typography>
//         )}

//         {/* helper text always at bottom */}
//         <Box sx={{ position: 'absolute', bottom: 8, textAlign: 'center' }}>
//           <Typography variant="caption" color="text.secondary" display="block">
//             Recommended ratio is 226:133
//           </Typography>
//           <Typography variant="caption" color="text.secondary">
//             Supported formats: PNG, JPG, and JPEG. Maximum file size: 10MB.
//           </Typography>
//         </Box>
//       </Paper>
//     </Box>
//   );
// };

// export default ImageDropzone;




// ImageDropzone.jsx
import React, { useCallback, useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { Box, Paper, Typography } from '@mui/material';

const ImageDropzone = ({ fieldName, formik, isEdit }) => {
  const { values, setFieldValue, touched, errors } = formik;

  const [preview, setPreview] = useState(null);

  // build preview URL whenever the file changes
  // useEffect(() => {
  //   // if(isEdit){
  //   //   setPreview(`${process.env.REACT_APP_API_ROUTE}/files/${values?.image}`)
  //   // }
  //   if (!values[fieldName]) {
  //     setPreview(null);
  //     return;
  //   }
  //   const url = URL.createObjectURL(values[fieldName]);
  //   setPreview(url);
  //   return () => URL.revokeObjectURL(url);
  // }, [values, fieldName]);


   useEffect(() => {
    // Edit mode: existing image string URL
    if (isEdit && values[fieldName] && typeof values[fieldName] === 'string') {
      setPreview(`${process.env.REACT_APP_API_ROUTE}/files/${values[fieldName]}`);
      return;
    }

    // New upload or file change
    if (values[fieldName] instanceof File) {
      const url = URL.createObjectURL(values[fieldName]);
      setPreview(url);
      return () => URL.revokeObjectURL(url);
    }

    // No image
    setPreview(null);
  }, [values[fieldName], isEdit, fieldName]);

  const onDrop = useCallback(
    files => setFieldValue(fieldName, files[0]),
    [setFieldValue, fieldName]
  );
  

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false,
    maxSize: 10 * 1024 * 1024,
    accept: { 'image/png': [], 'image/jpeg': [], 'image/jpg': [] },
  });

  //   const handleClear = () => {
  //   setFieldValue(fieldName, null);
  //   setPreview(null);
  // };


  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        border: '2px dashed #ccc',
        borderRadius: 2,
        position: 'relative',
        textAlign: 'center',
      }}
    >
      {/* inner draggable/clickable box */}
      <Box
        {...getRootProps()}
        sx={{
          width: 140,
          height: 140,
          mx: 'auto',
          border: '2px dashed #000',
          borderRadius: 1,
          bgcolor: '#e0e0e0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
        }}
      >
        <input {...getInputProps()} name={fieldName} />
        {preview ? (
          <Box
            component="img"
            src={preview}
            alt="Preview"
            sx={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
          />
        ) : (
          <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>
            {isDragActive
              ? 'Release to drop'
              : 'Drag & drop Food Item image here, or click to select file'}
          </Typography>
        )}
      </Box>

      {/* validation error */}
      {touched[fieldName] && errors[fieldName] && (
        <Typography variant="caption" color="error" sx={{ mt: 1, display: 'block' }}>
          {errors[fieldName]}
        </Typography>
      )}

      {/* helper text below */}
      <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: 'block' }}>
        Recommended ration is 226:133
      </Typography>
      <Typography variant="caption" color="text.secondary">
        Supported formats: PNG, JPG, and JPEG. Maximum file size: 10MB.
      </Typography>
    </Paper>
  );
};

export default ImageDropzone;
